export const INIT_APP = 'INIT_APP'
export function initApp(app){
    return function initApp(dispatch) {
        dispatch({ type: INIT_APP, app })
    }
}

export function openUrl(url) {
    return function openUrl() {
        window.open(url, '_blank')
    }
}

export const UPDATE_CSRF_TOKEN = 'UPDATE_CSRF_TOKEN'
export const updateCsrfToken = csrfToken => ({ type: UPDATE_CSRF_TOKEN, csrfToken })
